import { render } from "./Menu.vue?vue&type=template&id=8a8cc444&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=ts"
export * from "./Menu.vue?vue&type=script&lang=ts"

import "./Menu.vue?vue&type=style&index=0&id=8a8cc444&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8a8cc444"

export default script